<template>
    <div style="width: 100%;">
        
   <div
       style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 20px;">
       <!-- <div class="text"></div> -->
       <my-text-one :title="teamName + '更多内容'" :textContent="teamName + '更多内容'"></my-text-one>
       <div class="list-view" :style="{ height: screenHeight }">
           <el-row :gutter="40">
               <el-col :span="8" v-for="item,i in moreList" :key="i" @click="currentIndex = i">

                   <el-card :body-style="{ padding: '0px' }" >
                       <div style="width: 100%;height: 280px;display: flex;justify-content: center;align-items: center;" @click="goItem(i)">
                           <div class="nav">
                               <span style="--i:1;font-size: 40pt;">{{ item.title }}</span>
                           </div>
                       </div>
                   </el-card>
               </el-col>

           </el-row>

       </div>
       <div class="kuang">
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
           <div class="bubble"></div>
       </div>
   </div>
</div>

</template>

<script>
import LivePlayer from '@liveqing/liveplayer'
import MyTextOne from "@/components/MyTextOne.vue";
export default {
   name: 'MoreMobile',
   components: {
       LivePlayer,
       MyTextOne,
   },
   data() {
       return {
           // 屏幕宽度
           screenWidth: window.screen.width,
           // 屏幕高度
           screenHeight: (window.screen.height-380)+"px",
           // 分屏布局
           playerNum: 7,
           colSpan: 24,
           currentIndex: 0,
           // 视频播放器
           muted: false,
           autoplay: false,
           moreList: [
               {id:1,title:'乐器练习',link:'Sound',status:1},
               {id:2,title:'团队视频',link:'ShowVideo',status:1},
               {id:3,title:'团队建设',link:'ShowPicture',status:1},
               {id:4,title:'乐声播放',link:'MusicList',status:1},
            //    {id:5,title:'教学跟练',link:'',status:0},
            //    {id:6,title:'课程安排',link:'',status:0},
            //    {id:7,title:'学生进度',link:'',status:0},
               {id:8,title:'成员信息',link:'MemberList',status:1},
               {id:9,title:'VR接入',link:'VrGuide',status:1},
           ],

           dataForm: {
               key: ''
           },
           pageIndex: 1,
           pageSize: 10,
           dataListLoading: false,
           dataListSelections: [],
           addOrUpdateVisible: false
       };
   },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      }
    },
    methods: {
       // 获取数据列表
       getDataList() {
           this.dataListLoading = true
           this.$http({
               url: this.$http.adornUrl('/app/video/list'),
               method: 'get',
               params: this.$http.adornParams({
                   'page': this.pageIndex,
                   'limit': this.pageSize,
                   'key': this.dataForm.key
               })
           }).then(({ data }) => {
               console.log(data);
               if (data && data.code === 0) {
                   this.videoList = data.page.list
                   this.playerNum = data.page.totalCount
               } else {
                   this.videoList = []
                   this.totalPage = 0
               }
               this.dataListLoading = false
           })
       },
       
       onClickLeftBack(){
           this.$router.back()
       },
       goItem(index){
        console.log(index);
        let moreList = this.moreList
        let item = moreList[index]
        if (item.status<1) {
            return
        }
        this.$router.push({ name:item.link, query:{  } })
       },
   },
   mounted() {
    //    this.getDataList()
       console.log(this.screenHeight);
   },
   created() {
   }
}
</script>
<style lang="less" scoped>
.van-nav-bar{
   background-color: #00000000;
}
/* 需要滚动条隐藏的列表 */
.list-view {
   width: 95%;
   height: 760px;
   margin-top: 50px;
   overflow-x: hidden;
   overflow-y: auto;
   // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
   display: none;
}

.el-card {
   background-color: rgba(255, 255, 255, 0.15) !important;

   box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

   backdrop-filter: blur(50px) !important;
   border: none !important;
   border-radius: 10px !important;
//    opacity: 0.75;
}

.el-row {
   margin-bottom: 20px;
}

.el-row:last-child {
   margin-bottom: 0;
}

.el-col {
   border-radius: 4px;
   margin-bottom: 30px
}

.grid-content {
   border-radius: 4px;
   min-height: 36px;
}

/**背景 **/

* {
   margin: 0;
   padding: 0;
   box-sizing: border-box;
}

.kuang {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: -10;
   background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
   position: absolute;
   border-radius: 50%;
   border: 2px solid #fff;
   box-shadow: inset 0 0 8px #fff;
   animation: flutter 10s infinite;
   opacity: 0;
}

@keyframes flutter {
   0% {
       transform: translateX(0);
       bottom: -100px;
       opacity: 1;
   }

   50% {
       transform: translateX(100px);
       opacity: 0.5;
   }


   100% {
       transform: translateX(0px);
       bottom: 100%;
       opacity: 0;

   }
}

.bubble:nth-child(1) {
   left: -10%;
   width: 50px;
   height: 50px;
   animation-duration: 9s;
   animation-delay: 0.1s;
}

.bubble:nth-child(2) {
   left: 15%;
   width: 20px;
   height: 20px;
   animation-duration: 6s;
   animation-delay: 1.5s;

}

.bubble:nth-child(3) {
   left: 20%;
   width: 60px;
   height: 60px;
   animation-duration: 10s;



}

.bubble:nth-child(4) {
   left: 30%;
   width: 30px;
   height: 30px;
   animation-duration: 5.5s;
   animation-delay: 1.5s;

}

.bubble:nth-child(5) {
   left: 40%x;
   width: 50px;
   height: 50px;
   animation-duration: 12s;



}

.bubble:nth-child(6) {
   left: 50%;
   width: 20px;
   height: 20px;
   animation-duration: 6s;
   animation-delay: 1s;

}

.bubble:nth-child(7) {
   left: 60%;
   width: 40px;
   height: 40px;
   animation-duration: 8s;
   animation-delay: 1s;

}

.bubble:nth-child(8) {
   left: 65%;
   width: 60px;
   height: 60px;
   animation-duration: 15s;

}

.bubble:nth-child(9) {
   left: 80%;
   width: 55px;
   height: 55px;
   animation-duration: 9s;
   animation-delay: 0.5s;

}

.bubble:nth-child(10) {
   left: 100%;
   width: 40px;
   height: 40px;
   animation-duration: 12s;

}

/** 发光字体 */
.nav {
   position: relative;
   font: 8 10pt '';
   color: #ffffff;
   cursor: pointer;
   font-weight: bold;
}

.nav:hover span {
   color: #FFFFFF;
   text-shadow: 0 0 10px #FFFFFF,
       0 0 20px #FFFFFF,
       0 0 30px #FFFFFF,
       0 0 50px #FFFFFF,
       0 0 70px #FFFFFF,
       0 0 90px #FFFFFF;

}
</style>
